import { TableCell } from "../../../types/table";
import { SnackbarMessage } from "../types";

export const itemsListHeadCells: TableCell[] = [
  {
    id: "property_name",
    numeric: false,
    disablePadding: false,
    sortable: true,
    label: "propertiesList.objectName",
  },
  {
    id: "provider",
    numeric: false,
    disablePadding: false,
    sortable: false,
    label: "provider",
  },
  {
    id: "invoice_amount",
    numeric: false,
    disablePadding: false,
    sortable: false,
    label: "inbox.invoiceAmount",
  },
  {
    id: "invoice_date",
    numeric: false,
    disablePadding: false,
    sortable: false,
    label: "tenant.invoiceDate",
  },
  {
    id: "invoice_number",
    numeric: false,
    disablePadding: false,
    sortable: false,
    label: "optionalColumnsNames.number",
  },
  {
    id: "comment",
    numeric: false,
    disablePadding: false,
    sortable: false,
    label: "documentRelease.invoice.history.comment",
    align: "left",
  },
  {
    id: "file_name",
    numeric: false,
    disablePadding: true,
    sortable: true,
    label: "contracts.fileName",
  },
  {
    id: "status_name",
    numeric: false,
    disablePadding: false,
    sortable: false,
    label: "table.status",
  },
  {
    id: "full_name",
    numeric: false,
    disablePadding: false,
    sortable: true,
    label: "inbox.addedBy",
  },
  {
    id: "created_by",
    numeric: false,
    disablePadding: false,
    sortable: true,
    label: "companyOwnership.createdDate",
  },
  {
    id: "type",
    numeric: false,
    disablePadding: false,
    sortable: false,
    label: "inbox.dataType",
  },
  {
    id: "actions",
    numeric: false,
    disablePadding: false,
    sortable: false,
    label: "",
  },
];

export const snackbarInitState: SnackbarMessage = {
  text: "",
  visible: false,
  color: "success",
};

export const DATE_TIME_FORMAT = "DD.MM.YYYY HH:mm";
